<script>
    import Section from "../controls/Section.svelte";
    import TextField from "../controls/TextField.svelte";
    import Label from "../controls/LabelSetting.svelte";
    import ButtonDefault from "../controls/ButtonDefault.svelte";
    import MsgBoxOk from "../msgboxes/MsgBoxOk.svelte";
  
    let isShowCancelMessageBox = false;
  
    // Sample data for subscriptions and billing address
    let subscriptions = [
      {
        tier: "Pro",
        endDate: "2025-12-31",
        autoRenewal: true,
      },
    ];
    let billingAddress = {
      name: "John Doe",
      address: "123 Main St",
      city: "Metropolis",
      postalCode: "12345",
      country: "Exampleland",
    };
  
    function handleUpgrade() {
      // Implement upgrade functionality
      console.log("Upgrade subscription");
    }
  
    function cancelSubscription() {
      isShowCancelMessageBox = true;
    }
  
    function handleMsgBoxClose() {
      isShowCancelMessageBox = false;
    }
  </script>
  
  <div class="space-y-8 text-left">
    <!-- Subscriptions Section -->
    <Section title="Subscriptions" subtitle="Your current subscriptions and status">
      {#each subscriptions as sub}
        <div class="space-y-4">
          <p>Tier: {sub.tier}</p>
          <p>Ending Date: {sub.endDate}</p>
          <p>Auto-Renewal: {sub.autoRenewal ? "Enabled" : "Disabled"}</p>
  
          <div class="flex justify-end">
            <ButtonDefault text="Upgrade" isEnabled={true} onClick={handleUpgrade} />
          </div>
        </div>
      {/each}
    </Section>
  
    <!-- Billing Address Section -->
    <Section title="Billing Address" subtitle="The address associated with your billing">
      <div class="space-y-4">
        <div class="flex items-center space-x-4">
          <Label text="Name" />
          <TextField placeholder="Name" value={billingAddress.name} />
        </div>
        <div class="flex items-center space-x-4">
          <Label text="Address" />
          <TextField placeholder="Address" value={billingAddress.address} />
        </div>
        <div class="flex items-center space-x-4">
          <Label text="City" />
          <TextField placeholder="City" value={billingAddress.city} />
        </div>
        <div class="flex items-center space-x-4">
          <Label text="Postal Code" />
          <TextField placeholder="Postal Code" value={billingAddress.postalCode} />
        </div>
        <div class="flex items-center space-x-4">
          <Label text="Country" />
          <TextField placeholder="Country" value={billingAddress.country} />
        </div>
      </div>
    </Section>
  
    <!-- Cancel Subscription Section -->
    <Section title="Cancel Subscription" subtitle="Stop your subscription and payments">
      <p>
        By canceling your subscription, you will no longer be billed and your access
        to premium features will end after the current subscription period.
      </p>
      <div class="flex justify-end">
        <ButtonDefault text="Cancel Subscription" isEnabled={true} onClick={cancelSubscription} />
      </div>
    </Section>
  </div>
  
  {#if isShowCancelMessageBox}
  <MsgBoxOk
    title="Cancel Subscription"
    message="Your subscription has been canceled. You will retain access until the end of your current billing period."
    onClose={handleMsgBoxClose}
  />
  {/if}
  